import React from "react";
import "./submenu.css";
import Mediaobject from "./mediaObjects/Mediaobject";
import { Link } from "react-router-dom";
const SubMenu = ({ data, isVisible, className }) => {
  return (
    <div
      className={`submenu-wrapper  ${isVisible ? "show-dropdown-menu" : ""} `}
    >
      <div
        className={`container links-column-wrapper ${className}`}
        style={{ marginTop: "50px" }}
      >
        {data[0].header ? (
          data.map((item, i) => {
            return (
              <div
                className={`  ${
                  data[0].links.image ? "link-image-column" : "link-column"
                }`}
                style={{
                  flexShrink: 0,
                  fontWeight: 900,
                }}
              >
                <h3>{item.header}</h3>
                <div
                  className="links-column-inner"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {item.links.image ? (
                    <img
                      style={{
                        width: "260px",
                      }}
                      src={item.links.image}
                      alt=""
                    />
                  ) : (
                    item.links.map((link, i) => (
                      <Link to={link.link}>
                        <Mediaobject
                          img={link.img}
                          para={link.para}
                          mediaheading={link.mediaheading || link.heading}
                        />
                      </Link>
                    ))
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <div
            className="links-without-heading"
            style={{
              width: "100%",
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            {data.map((item, i) => {
              return (
                <Link to={item.link}>
                  <Mediaobject
                    img={item.img}
                    para={item.para}
                    mediaheading={item.mediaheading}
                  />
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default SubMenu;
